import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Database, ref, update, push, set } from '@angular/fire/database';
import { LocalService } from './local.service';
import { GlobalsService } from './globals.service';
import { from, of, switchMap, tap, catchError, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrashReportingService {
  ip: string = '';
  coreAPI: string = 'https://apis.zenithr.net/api/'; //'http://localhost:52619/api/';

  constructor(private db: Database, private http: HttpClient, private localService: LocalService,
    private globals: GlobalsService
  ) {
    this.coreAPI = this.globals.coreAPI;
  }

  updateCoreUserLog(log: any) {
    return this.http.post(
      this.coreAPI + 'PlatformUser/UpdateUserLog',
      log
    );
  }

  /**
   * 
   * @param code Log Code
   * @param json JSON Strigified Extra Data
   */
  submitLogCode(code: number, json?: string) {
    const userKey = this.localService.getJsonValue('UserKey');
    const userEmail = this.localService.getJsonValue('UserEmail');

    if (!userKey) return of(null); // no user, nothing to log

    const activityTimeStamp = Date.now();
    const logKey = push(ref(this.db, `PlatformUsersLog/${userKey}/Logs`)).key!;
    const access = this.localService.getJsonValue('Access') ?? '';
    const log = {
      key: logKey,
      logCode: code,
      timeStamp: activityTimeStamp,
      ip: access,
      email: userEmail,
      DateCreated: activityTimeStamp,
    };

    // Write to Firebase
    const userLogRef = ref(this.db, `PlatformUsersLog/${userKey}/Logs/${log.key}`);
    const coreLog$ = this.updateCoreUserLog({ ...log, ExtraData: json }); // Observable

    from(update(userLogRef, log)).pipe(
      first(),
      switchMap(() => coreLog$) // run after log write
    ).subscribe();
  }

  updateLastLogginInInformation(userKey: string) {
    from(fetch('https://api.ipify.org/?format=json')).pipe(
      switchMap(response => response.json()),
      switchMap(response => {
        const ip = response.ip;
        const geoUrl = `https://api.ipgeolocation.io/ipgeo?apiKey=d8238b326e1646b3a5202391e9a66a6f&ip=${ip}`;
        return this.http.get<any>(geoUrl).pipe(
          tap(geoResponse => {
            this.ip = geoResponse.ip;

            // Update security information
            this.updateSecurityInformation(userKey, geoResponse)

            // Save IP locally
            const replacedIP = this.ip.replace(/\./g, '-');
            this.localService.setJsonValue('Access', this.ip);

            // Submit login code
            this.submitLogCode(1, JSON.stringify(geoResponse));
          })
        );
      }),
      catchError(error => {
        console.error('Error updating login info:', error);
        return of(null);
      })
    ).subscribe();
  }

  updateSecurityInformation(userKey: string, geoResponse: any) {
    const path = `PlatformUsersLog/${userKey}/MoreInformation/SecurityInformation`;

    const securityInfo = {
      ip: geoResponse.ip,
      country: geoResponse.country_name,
      city: geoResponse.city,
      district: geoResponse.district,
      latitude: geoResponse.latitude,
      longitude: geoResponse.longitude,
    };

    // ✅ Modular syntax (AngularFire 17+)
    return set(ref(this.db, path), securityInfo);
  }

}
